module.exports = __webpack_public_path__ + "media/images/logo-20minutesfr-blanc-3f866436a367d9f655adaddebdeed835.png";